<template>
  <span class="more" @click="loadMore">查看更多</span>
</template>

<script>
export default {
  name: "LoadMoreButton",
  data() {
    return {};
  },
  methods: {
    loadMore() {
      this.$emit("loadMore");
    },
  },
};
</script>

<style scoped lang="scss">
.more {
  width: 100%;
  height: 120px;
  line-height: 120px;
  color: #ffffff;
  text-align: center;
  font-size: 48px;
  background: #247cfd;
  border-radius: 8px;
  display: inline-block;
}
</style>
